<template>
  <section class="main-content">
    <section class="wrap-content popup-content">
      <header>
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="$emit('close')"
          :width="20"
          :height="20"
          :padding="'0px'"
          :style="{ color: 'var(--icon)' }"
        />
      </header>
      <div class="body">
        <!-- <aside v-if="propsData.sideBar">
          <ol>
            <li
              v-for="item in propsData.entity"
              @click="setEntityData(item, propsData.entity.indexOf(item))"
              :class="currentEntity == propsData.entity.indexOf(item) ? 'active' : ''"
            >
              {{ item[0] == "t" && item[1] == "p" ? item.slice(2) : item }}
            </li>
          </ol>

          <ul>
            <li>Imprimir</li>
            <li>outros</li>
          </ul>
        </aside> -->

        <section v-if="!pagination" class="content max-w-full">
          <AppTable
            :show_export="false"
            :status="entityResponseStatus"
            :noClose="true"
            :simple="true"
            :visibility="true"
            :show="true"
            :hiddenHeaders="hiddenHeaders"
            :table_data="entityData"
            :table_title="
              propsData.title
                ? propsData.title
                : customEtityName(propsData.entity[currentEntity], true)
            "
            @row-dClicked="ConfirmDialog"
            @row-clicked="selectRowData"
            @close="null"
          />
        </section>
        <section v-else class="content max-w-full">
          <!-- Filtros em cascata (cliente -> subcliente -> local instalação).
               Só aparece quando estamos a selecionar locais de instalação. -->
          <div v-if="isLocalInstalacaoEntity" class="li-filter-bar">
            <div class="li-filter-field">
              <label>Cliente:</label>
              <!-- Pesquisa server-side com debounce: não carrega todos os clientes -->
              <multiselect
                v-model="filterCliente"
                :options="clienteOptions"
                :multiple="false"
                :searchable="true"
                :loading="clientesLoading"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="50"
                :max-height="240"
                :show-no-results="true"
                placeholder="Digite para buscar cliente..."
                select-label=""
                selected-label=""
                deselect-label=""
                label="cliente"
                track-by="id"
                @search-change="buscarClientes"
                class="li-multiselect"
              >
                <template #noResult>Nenhum cliente encontrado.</template>
                <template #noOptions>Digite pelo menos 3 caracteres...</template>
              </multiselect>
            </div>
            <div class="li-filter-field">
              <label>SubCliente:</label>
              <select
                v-model="filterSubcliente"
                :disabled="!filterCliente"
                @change="onSubclienteChange"
              >
                <option value="">Todos os subclientes</option>
                <option v-for="s in subclienteOptions" :key="s.id" :value="s.id">
                  {{ s.nome }}
                </option>
              </select>
            </div>
          </div>

          <!-- Filtros da seleção de serviço (equipamento por familia). A familia
               já vem da seleção anterior, por isso não tem filtro próprio. -->
          <div v-if="isEquipamentoServicoEntity" class="li-filter-bar">
            <div class="li-filter-field">
              <label>Serviço:</label>
              <select v-model="equipFilters.tpServico_id" @change="onEquipFilterChange">
                <option value="">Todos</option>
                <option v-for="o in equipFacets.servicos" :key="o.id" :value="o.id">{{ o.nome }}</option>
              </select>
            </div>
            <div class="li-filter-field">
              <label>Produto:</label>
              <select v-model="equipFilters.produto_id" @change="onEquipFilterChange">
                <option value="">Todos</option>
                <option v-for="o in equipFacets.produtos" :key="o.id" :value="o.id">{{ o.nome }}</option>
              </select>
            </div>
            <div class="li-filter-field">
              <label>Tipologia:</label>
              <select v-model="equipFilters.tipologia_id" @change="onEquipFilterChange">
                <option value="">Todas</option>
                <option v-for="o in equipFacets.tipologias" :key="o.id" :value="o.id">{{ o.nome }}</option>
              </select>
            </div>
            <div class="li-filter-field">
              <label>Medida:</label>
              <select v-model="equipFilters.tpMedida_id" @change="onEquipFilterChange">
                <option value="">Todas</option>
                <option v-for="o in equipFacets.medidas" :key="o.id" :value="o.id">{{ o.nome }}</option>
              </select>
            </div>
            <div class="li-filter-field">
              <label>Marca:</label>
              <select v-model="equipFilters.tpMarca_id" @change="onEquipFilterChange">
                <option value="">Todas</option>
                <option v-for="o in equipFacets.marcas" :key="o.id" :value="o.id">{{ o.nome }}</option>
              </select>
            </div>
          </div>

          <AppTablePagination
            :visibility="true"
            :show_export="false"
            :show="true"
            :table_title="propsData.title? propsData.title
                : customEtityName(propsData.entity[currentEntity], true)
            "
            @row-clicked="selectRowData"
            @close="null"
            class="h-full"
            @row-dClicked="ConfirmDialog"
            :page_display="10"
            :specialQuery="propsData.specialQuery? propsData.specialQuery[propsData.entity[currentEntity]] : null"
            :refresh="refresh"
            @refreshed="refresh = false"
            :urlString="propsData.entity[currentEntity]"
            :finalUrl="effectiveFinalUrl"

            :multiSelect="{
              show: multiSelectOptions.enabled,
              isActive: multiSelectOptions.enabled,
              buttons: {
                add: {
                  show: multiSelectOptions.show_btn,
                  enabled: true,
                  text: '',
                  color: '#ff9b05',
                  icon: 'fa-solid fa-pen-to-square',
                  emit: 'send-selected-rows',
                },
                delete: {
                  show: multiSelectOptions.show_btn,
                  enabled: false,
                  text: '',
                  color: 'red',
                  icon: 'fa-solid fa-trash-alt',
                  emit: 'remove-selected-rows',
                },
              },
            }"
            
            @multiRow-clicked="selectMultiRowData"
          />
        </section>
      </div>
      <div class="footer pt-6">
        <section class="left">
          <button
            v-for="item in propsData.buttons"
            class="p-1 text-[.7em] rounded-md bg-[#006698]"
            @click="dinamicButton(item)"
          >
            {{ item }}
          </button>
        </section>
        <section class="right flex gap-2 px-2">
          <button
            class="p-1 text-[.7em] rounded-md" :style="{ backgroundColor: 'var(--vermelho)', color: 'var(--button-color)' }"
            @click="CancelDialog"
          >
            Cancelar
          </button>
          <button
            class="p-1 text-[.7em] rounded-md" :style="{ backgroundColor: 'var(--button)', color: 'var(--button-color)' }"
            @click="ConfirmDialog"
          >
            Confirmar
          </button>
        </section>
      </div>
      <!-- <ConfirmDialog @response="responseConfirm"/> -->
    </section>
  </section>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import AppTable from "@/components/tables/table.vue";
import axios from "axios";
import ConfirmDialog from "@/components/dialog/confirmDialog.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { toast } from "vue3-toastify";

export default {
  components: {
    AppButton,
    AppTable,
    ConfirmDialog,
    AppTablePagination,
    Multiselect,
  },
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {
          entity: ["equipamento"],
          buttons: [],
          sideBar: true,
          multi: false,
          specialQuery: null,
          title: null,
          // currentEntity: 'equipamento',
        };
      },
    },
    multiSelectOptions: {
      type: Object,
      default: { enabled: false, show_btn: false },
    },
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: true,
      entityResponseStatus: 200,
      entityData: [],
      refresh: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      currentEntity: 0,
      selectedRow: { index: 0, data: {} },
      selectedRow2: [],
      sendMultiData: false,
      hiddenHeaders: ['id', 'cliente_id','logotipo','endereco_id', 'endereco'],
      // Filtros em cascata para locais de instalação
      filterCliente: null,
      filterSubcliente: '',
      clienteOptions: [],
      subclienteOptions: [],
      clientesLoading: false,
      clientesSearchTimeout: null,
      // Filtros da seleção de serviço (equipamento por familia)
      equipFilters: {
        tpServico_id: '',
        produto_id: '',
        tipologia_id: '',
        tpMedida_id: '',
        tpMarca_id: '',
      },
      equipFacets: {
        servicos: [],
        produtos: [],
        tipologias: [],
        medidas: [],
        marcas: [],
      },
    };
  },
  computed: {
    // Verifica se a entidade atual é 'localinstalacao' para mostrar os filtros
    isLocalInstalacaoEntity() {
      return this.propsData?.entity?.[this.currentEntity] === 'localinstalacao';
    },
    // Os fluxos de criação de negócio pedem a lista de locais com only_active=true
    // (o backend já exclui locais inativos e locais de cliente/subcliente inativos).
    // Quando isso acontece, os filtros de cliente e subcliente deste diálogo também
    // só podem oferecer entidades ativas — senão dava para escolher aqui um cliente
    // desativado ao qual não é suposto associar nada.
    soEntidadesAtivas() {
      return /(?:^|&)only_active=(?:1|true|yes)(?:&|$)/i.test(this.propsData?.finalUrl || '');
    },
    // Verifica se estamos na seleção de serviço (equipamento por familia)
    isEquipamentoServicoEntity() {
      const entity = this.propsData?.entity?.[this.currentEntity] || '';
      return typeof entity === 'string' && entity.startsWith('equipamento/filter/familia/');
    },
    // Extrai familia_id / local_id do url da entidade de serviço
    equipParams() {
      const entity = this.propsData?.entity?.[this.currentEntity] || '';
      const m = entity.match(/familia\/(\d+)(?:\/local\/(\d+))?/);
      return m ? { familia_id: m[1], local_id: m[2] || 0 } : { familia_id: null, local_id: 0 };
    },
    // finalUrl base + filtros aplicados consoante a entidade
    effectiveFinalUrl() {
      const base = this.propsData.finalUrl || 'l=1';

      if (this.isLocalInstalacaoEntity) {
        const parts = base
          .split('&')
          .filter(
            (p) =>
              p &&
              !/^cliente_id=/.test(p) &&
              !/^subcliente_id=/.test(p)
          );

        const clienteId = this.filterCliente?.id;
        if (clienteId) parts.push(`cliente_id=${clienteId}`);
        if (this.filterSubcliente) parts.push(`subcliente_id=${this.filterSubcliente}`);

        return parts.join('&') || 'l=1';
      }

      if (this.isEquipamentoServicoEntity) {
        const keys = ['tpServico_id', 'produto_id', 'tipologia_id', 'tpMedida_id', 'tpMarca_id'];
        const parts = base
          .split('&')
          .filter((p) => p && !keys.some((k) => p.startsWith(`${k}=`)));

        keys.forEach((k) => {
          const v = this.equipFilters[k];
          if (v) parts.push(`${k}=${v}`);
        });

        return parts.join('&') || 'l=1';
      }

      return base;
    },
  },
  methods: {
    // Só remove os desativados quando o diálogo está em modo "só entidades ativas".
    // Filtra pela negativa para que um registo sem 'status' na resposta continue
    // a aparecer, em vez de esvaziar a lista toda.
    filtrarAtivos(lista) {
      if (!Array.isArray(lista)) return [];
      if (!this.soEntidadesAtivas) return lista;
      return lista.filter(
        (item) => item && item.status !== 'desativado' && item.status !== 'eliminado'
      );
    },
    // Pesquisa server-side de clientes com debounce (evita carregar todos)
    buscarClientes(query) {
      if (this.clientesSearchTimeout) {
        clearTimeout(this.clientesSearchTimeout);
      }
      const term = (query || '').trim();
      if (term.length < 3) {
        this.clienteOptions = [];
        return;
      }
      this.clientesSearchTimeout = setTimeout(() => {
        this.executarBuscaClientes(term);
      }, 350);
    },
    async executarBuscaClientes(term) {
      this.clientesLoading = true;
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/cliente/s/cliente/${encodeURIComponent(term)}/`
        );
        this.clienteOptions = this.filtrarAtivos(res.data?.data || []);
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
        this.clienteOptions = [];
      } finally {
        this.clientesLoading = false;
      }
    },
    async fetchSubclientes(clienteId) {
      try {
        // Endpoint leve (raw query) que devolve só os subclientes do cliente
        const res = await axios.get(
          `${this.baseURl}/api/v1/subcliente/?cliente_id=${clienteId}`
        );
        this.subclienteOptions = this.filtrarAtivos(res.data?.data || []);
      } catch (err) {
        console.error('Erro ao buscar subclientes:', err);
        this.subclienteOptions = [];
      }
    },
    onSubclienteChange() {
      this.triggerTableRefresh();
    },
    // Carrega as opções (facetas) dos filtros de serviço para a familia atual
    async fetchEquipFacets() {
      const { familia_id, local_id } = this.equipParams;
      if (!familia_id) return;
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/equipamento/filter/familia/${familia_id}/facets/?local_id=${local_id || 0}`
        );
        const d = res.data?.data || {};
        this.equipFacets = {
          servicos: d.servicos || [],
          produtos: d.produtos || [],
          tipologias: d.tipologias || [],
          medidas: d.medidas || [],
          marcas: d.marcas || [],
        };
      } catch (err) {
        console.error('Erro ao buscar facetas de serviço:', err);
      }
    },
    onEquipFilterChange() {
      this.triggerTableRefresh();
    },
    // O AppTablePagination não observa finalUrl diretamente; forçamos o refetch
    // via prop 'refresh' depois de a finalUrl (computed) estar atualizada.
    triggerTableRefresh() {
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
    responseConfirm(response) {
      if (response) {
        console.log("Confirmado");
      } else {
        console.log("Cancelado");
      }
    },

    ConfirmDialog() {
      //J...06_02_2025
      if (
        !this.selectedRow2 ||
        (Array.isArray(this.selectedRow2) && this.selectedRow2.length === 0) ||
        (!this.propsData.multi && !this.selectedRow2[0])
      ) {
        toast.info("Por favor, selecione uma linha antes de confirmar!", {
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      if (this.propsData.multi) {
        let customizedEntityData = [];
        for (const key in this.selectedRow2) {
          customizedEntityData.push({
            [this.propsData.entity[key]]: this.selectedRow2[key],
          });
        }

        // if()
        this.$emit("returnData", customizedEntityData);
      } else {
        if (this.sendMultiData) {
          console.log("Multi data: ", this.selectedRow2);
          if (this.propsData.title) {
            this.$emit("returnData", {
              [this.propsData.title]: this.selectedRow2,
            });
          } else
            this.$emit("returnData", {
              [this.propsData.entity[0]]: this.selectedRow2,
            });
        } else if (this.propsData.title) {
          this.$emit("returnData", {
            [this.propsData.title]: this.selectedRow2[0],
          });
        } else
          this.$emit("returnData", {
            [this.propsData.entity[0]]: this.selectedRow2[0],
          });
      }

      this.$emit("close");
    },

    CancelDialog() {
      // if(this.selectedRow2.length > 0){

      // }else{
      this.selectedRow2 = [];
      this.$emit("close");

      // }
    },

    closeDialog() {
      this.isOpen = false;
    },

    selectRowData(row) {
        console.log("Row: ", row);
      this.sendMultiData = false;
      this.selectedRow = { index: this.currentEntity, data: row };
      this.selectedRow2[this.currentEntity] = row;

      // console.table(this.selectedRow2);
    },
    selectMultiRowData(rows) {
      console.log("Rows: ", rows);
      this.sendMultiData = true;

      this.selectedRow2 = rows;
      // console.table(this.selectedRow2);
    },

    setEntityData(entity, index) {
      this.currentEntity = index;
      this.fetchAll(entity);
    },

    customEtityName(entity, plural = false) {
      let final = "";
      if (plural) {
        final = "s";
      }

      if (entity[0] == "t" && entity[1] == "p" && entity[3]) {
        // return entity[2].toUpperCase() + entity.slice(3) + final;
        return "Tipos de " + entity[2].toUpperCase() + entity.slice(3);
      } else {
        return entity[0].toUpperCase() + entity.slice(1);
      }
    },

    async fetchAll(entity) {
      let url = `${this.baseURl}/api/v1/${entity}/`;

      try {
        // const specialQuery = this.propsData?.specialQuery;
        // const entity = this.propsData?.entity;
        // const currentEntity = this.currentEntity;

        // if(this.propsData.queryParams[[this.propsData.entity[this.currentEntity]]]){
        try {
          let newUrl = `${this.baseURl}/api/v1/${entity}/?${
            this.propsData.queryParams[
              [this.propsData.entity[this.currentEntity]]
            ]
          }`;
          url = newUrl;
        } catch (err) {
          // url = `${this.baseURl}/api/v1/${entity}/`;
        }
        // console.log('Query: => ',this.propsData.specialQuery);

        // if(this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]]){

        // if(this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]] != null && this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]] != undefined){

        if (
          this.propsData.specialQuery &&
          this.propsData.specialQuery[[entity]]
        ) {
          if (this.propsData.specialQuery[[entity]] == null) {
            console.log("Special query nulo");
            return;
          }

          let newUrlurl = `${this.baseURl}/api/v1/${
            this.propsData.specialQuery[
              [this.propsData.entity[this.currentEntity]]
            ]
          }`;
          url = newUrlurl;
          // console.log('Veio com o special query');
        } else {
          // console.log('Nao veio com o special query');
        }

        let res = await axios.get(url);

        this.entityData = res.data.data;
        this.entityResponseStatus = res.status;
        // console.log('Dados de {'+entity+'}: ',this.entityData);
      } catch (err) {
        console.log("URL: ", url);
        console.log("Erro ao fazer fetch no dialog de {" + entity + "}: ", err);
      }
    },
  },
  mounted() {
    // this.makeElementDraggable(document.querySelector('.wrap-content'));

    let header = document.querySelector(".wrap-content header");
    let content = document.querySelector(".wrap-content");

    let isDragging = false;
    let offsetX, offsetY;

    header.addEventListener("mousedown", (e) => {
      isDragging = true;
      offsetX = e.clientX - content.offsetLeft;
      offsetY = e.clientY - content.offsetTop;
      content.style.width = `${content.offsetWidth}px`; // Fixar a largura
      content.style.height = `${content.offsetHeight}px`; // Fixar a altura
    });

    // header.addEventListener('mouseup', () => {
    //     header.style.cursor = 'grabbing';
    // });

    document.addEventListener("mousemove", (e) => {
      if (isDragging) {
        content.style.left = `${e.clientX - offsetX}px`;
        content.style.top = `${e.clientY - offsetY}px`;
      }
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
    });
  },
  created() {
    console.log("Props Data Dinamic Dialog: ", this.propsData);
    if(!this.pagination){
      this.fetchAll(this.propsData.entity[0]);
    }
    this.propsData.sideBar = this.propsData.multi;
    // Carrega as opções dos filtros da seleção de serviço
    if (this.isEquipamentoServicoEntity) {
      this.fetchEquipFacets();
    }
  },

  watch: {
    pagination: {
      handler() {
        this.refresh = true;
      },
    },
    // Cascata: ao mudar o cliente, recarrega subclientes e refiltra a tabela
    filterCliente(val) {
      this.filterSubcliente = '';
      this.subclienteOptions = [];
      if (val?.id) {
        this.fetchSubclientes(val.id);
      }
      this.triggerTableRefresh();
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 3em;
  padding-left: 5em;
  padding-top: 6em;
  background-color: var(--bg-pop-up);
  border-radius: 1em;
  /*width: 100%; */
  width: 100vw;
  height: 100dvh;
  position: fixed;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 10000;
}

.wrap-content {
  position: relative;
  padding: 1em;
  border-radius: 0.2em;
  color: var(--label);
  width: fit-content;
  height: fit-content;
  min-height: 20em;
  min-width: 30em;
  max-height: 90vh;

  /* Fazer scroll*/
  overflow-y: auto;
  overflow-x: hidden;
  /* cursor: move; */

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: absolute;
  top: 3em;
  left: 50%;
  transform: translateX(-50%);
  /*transform: translate(-50%, -50%);
        cursor: move; */
}

.wrap-content header {
  display: flex;
  justify-content: flex-end;
  padding: 0.3em;
  padding-bottom: 0.5em;
}

.body {
  display: flex;
  justify-content: space-between;

  gap: 1em;
}

aside {
  min-height: 20em;
  border-radius: 0.2em;
  font-size: 0.7em;
  padding-top: 1em;
  color: #fffb;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

aside ol li {
  cursor: pointer;
  padding: 0.1em;
  color: #fff9;
  border-radius: 0.2em;
  padding: 0.3em;
}
aside ol li.active {
  color: var(--text);
}

aside ol li:hover {
  background-color: rgba(0, 0, 0, 0.193);
}

.footer {
  display: flex;
  justify-content: space-between;
  gap: 1em;
  /* Mantém os botões Cancelar/Confirmar acima da tabela (que tem height:100%)
     para que fiquem sempre clicáveis */
  position: relative;
  z-index: 5;
}

/* Barra de filtros em cascata (cliente -> subcliente) para locais de instalação.
   Cada filtro ocupa 50% do espaço e o campo preenche 100% da sua metade. */
.li-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  margin-bottom: 0.8em;
  width: 100%;
}

.li-filter-field {
  /* base de 8em: 2 filtros -> 50/50; 5 filtros -> repartem e quebram se preciso */
  flex: 1 1 8em;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  font-size: 0.8em;
  color: var(--label);
}

.li-filter-field label {
  font-weight: 600;
}

.li-filter-field select,
.li-filter-field .li-multiselect {
  width: 100%;
}

.li-filter-field select {
  padding: 0.35em 0.5em;
  border-radius: 0.4em;
  border: 1px solid var(--glass-border);
  background-color: var(--fundoForm);
  color: var(--text);
  outline: none;
}

.li-filter-field select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Multiselect (pesquisa de cliente) — inherits from global theme CSS */
.li-multiselect {
  color: inherit;
}

</style>